module.exports = __webpack_public_path__ + "media/请美女点击一个听后感想.3b35bb75.mp3";